import { Providers } from "@microsoft/mgt-element";
import { IUserInfo } from "../common/Interfaces/IUserInfo";
import { Dispatch, SetStateAction } from "react";

export const fetchLoggedInUser = async (setUserInfo: Dispatch<SetStateAction<IUserInfo>>) => {
  const gotMe: any = await Providers.globalProvider.graph.client
    .api("me")
    .get();
  setUserInfo({
    id: gotMe.id,
    displayName: gotMe.displayName,
  });
};
